<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";

const authStore = useAuthStore();
const router = useRouter();

onBeforeMount(async () => {
  await authStore.logout();
  router.push("/");
});
</script>
<template></template>
